import { fromZonedTime } from "date-fns-tz";

/**
 * Converts a date string to a Date object in the target timezone
 * @param dateStr - The date string to convert
 * @param timezone - The timezone to convert the date to
 * @returns The Date object in the target timezone
 */

export function dateStringToDate(
  dateStr: string | null,
  timezone?: string,
): Date | undefined {
  if (!dateStr) return undefined;

  const [month, day, year] = dateStr.split("-").map(Number);

  let date = new Date(year, month - 1, day, 0, 0, 0);
  if (timezone) {
    // Create date at midnight in the target timezone
    date = fromZonedTime(date, timezone);
  }

  return date;
}
